import React from "react"
import { ListOfUsers } from "./ListOfUsers"

const Users = () => {


    return (
        <>
            <ListOfUsers />
        </>
    )
}

export { Users }